import ticketAPI from "../api/ticketAPI";

const state = {
  addons: [],
  addonsHistory: [],
  isFetching: false,
  hasFetchedAddons: false,
};

const actions = {
  async fetchAddons({commit}, {id}) {
    commit("updateIsFetching", true);

    try {
      const response = await ticketAPI.fetch(id);
      commit("updateAddons", response);
    } catch (error) {
      console.error('Failed to fetch notification:', error);
    } finally {
      commit("updateIsFetching", false);
    }
  }
};

const mutations = {
  updateAddons(state, payload) {
    state.addons = [
      ...payload.data.data.addons,
    ];
    state.addonsHistory = [
      ...payload.data.data.history,
    ];
    state.hasFetchedAddons = true;
  },

  updateIsFetching(state, isFetching) {
    state.isFetching = isFetching;
  },
};

const getters = {
  addons(state) {
    return state.addons;
  },

  addonsHistory(state) {
    return state.addonsHistory;
  },

  isFetching(state) {
    return state.isFetching;
  },

  hasFetchedAddons(state) {
    return state.hasFetchedAddons;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
